import { render, staticRenderFns } from "./OnboardingNymCard.vue?vue&type=template&id=39b38e96&"
import script from "./OnboardingNymCard.vue?vue&type=script&lang=js&"
export * from "./OnboardingNymCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports